import { jsx as t, Fragment as v, jsxs as d } from "react/jsx-runtime";
import * as o from "@radix-ui/react-tooltip";
import { forwardRef as T } from "react";
const h = o.Provider, u = ({
  children: r,
  label: e,
  side: n = "top",
  sideOffset: i = 6,
  delayDuration: l = 200,
  open: a,
  defaultOpen: s,
  onOpenChange: p,
  withArrow: c,
  disabled: m
}) => m ? /* @__PURE__ */ t(v, { children: r }) : /* @__PURE__ */ d(
  o.Root,
  {
    delayDuration: l,
    open: a,
    defaultOpen: s,
    onOpenChange: p,
    children: [
      /* @__PURE__ */ t(o.Trigger, { asChild: !0, children: r }),
      /* @__PURE__ */ t(f, { side: n, sideOffset: i, withArrow: c, children: e })
    ]
  }
), f = T(function({ className: e, withArrow: n, sideOffset: i = 6, children: l, ...a }, s) {
  return /* @__PURE__ */ t(o.Portal, { children: /* @__PURE__ */ d(
    o.Content,
    {
      ref: s,
      sideOffset: i,
      className: [
        "ls-tooltip-content",
        "pointer-events-none select-none",
        "rounded-md border px-2 py-1",
        "text-2xs font-medium",
        "shadow-sm",
        e
      ].filter(Boolean).join(" "),
      style: {
        backgroundColor: "var(--bg-elevated)",
        borderColor: "var(--border-strong)",
        color: "var(--text-primary)",
        boxShadow: "var(--shadow-sm)",
        maxWidth: 240,
        zIndex: "var(--z-tooltip)",
        fontSize: "var(--text-2xs)"
      },
      ...a,
      children: [
        l,
        n ? /* @__PURE__ */ t(o.Arrow, { width: 10, height: 5, style: { fill: "var(--bg-elevated)" } }) : null
      ]
    }
  ) });
}), b = o.Root, w = o.Trigger, C = o.Portal, P = o.Arrow;
export {
  u as T,
  P as a,
  f as b,
  C as c,
  h as d,
  b as e,
  w as f
};
//# sourceMappingURL=Tooltip-g6iElNQB.js.map
